"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var colors_1 = require("@mui/material/colors");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var Stripe = function (_a) {
    var price = _a.price, clientSecret = _a.clientSecret;
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var _b = __read((0, react_1.useState)(null), 2), paymentRequest = _b[0], setPaymentRequest = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), isWalletAvailable = _c[0], setIsWalletAvailable = _c[1];
    // state
    var _d = __read((0, react_1.useState)(undefined), 2), message = _d[0], setMessage = _d[1];
    var _e = __read((0, react_1.useState)(undefined), 2), walletError = _e[0], setWalletError = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), isLoading = _f[0], setIsLoading = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), useCard = _g[0], setUseCard = _g[1];
    // vars
    var redirectUrl = "".concat(window.location.protocol, "//").concat(window.location.host, "/confirmacion");
    var ConfirmButton = (0, material_1.styled)(material_1.Button)(function (_a) {
        var theme = _a.theme;
        return ({
            color: theme.palette.getContrastText(colors_1.green[500]),
            backgroundColor: colors_1.green[500],
            '&:hover': {
                backgroundColor: colors_1.green[700],
            },
        });
    });
    var CardButton = (0, material_1.styled)(material_1.Button)(function (_a) {
        var theme = _a.theme;
        return ({
            color: '#fff',
            backgroundColor: colors_1.blue[500],
            height: 40,
            marginTop: 5,
            textTransform: 'none',
            '&:hover': {
                backgroundColor: colors_1.blue[700],
            },
        });
    });
    (0, react_1.useEffect)(function () {
        if (stripe) {
            if (!price)
                return;
            var priceInt = parseInt(price);
            if (isNaN(priceInt))
                return;
            var pr_1 = stripe.paymentRequest({
                country: 'ES',
                currency: 'eur',
                total: {
                    label: 'Opositando',
                    amount: priceInt,
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });
            pr_1.canMakePayment().then(function (result) {
                if (result) {
                    setPaymentRequest(pr_1);
                    setIsWalletAvailable(true);
                }
                else {
                    setIsWalletAvailable(false);
                }
            });
        }
    }, [stripe]);
    (0, react_1.useEffect)(function () {
        if (paymentRequest && stripe) {
            paymentRequest.on('paymentmethod', function (ev) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, paymentIntent, confirmError, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, stripe.confirmCardPayment(clientSecret, { payment_method: ev.paymentMethod.id }, { handleActions: false })];
                        case 1:
                            _a = _b.sent(), paymentIntent = _a.paymentIntent, confirmError = _a.error;
                            if (!confirmError) return [3 /*break*/, 2];
                            // Report to the browser that the payment failed, prompting it to
                            // re-show the payment interface, or show an error message and close
                            // the payment interface.
                            ev.complete('fail');
                            return [3 /*break*/, 5];
                        case 2:
                            // Report to the browser that the confirmation was successful, prompting
                            // it to close the browser payment method collection interface.
                            ev.complete('success');
                            if (!(paymentIntent.status === "requires_action")) return [3 /*break*/, 4];
                            return [4 /*yield*/, stripe.confirmCardPayment(clientSecret)];
                        case 3:
                            error = (_b.sent()).error;
                            if (error) {
                                // The payment failed -- ask your customer for a new payment method.
                                setWalletError('El pago ha fallado. Por favor, intente mediante otro método de pago.');
                            }
                            else {
                                window.location.href = "".concat(redirectUrl, "?payment_intent_client_secret=").concat(clientSecret);
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            window.location.href = "".concat(redirectUrl, "?payment_intent_client_secret=").concat(clientSecret);
                            _b.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
        }
    }, [paymentRequest, stripe]);
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!stripe || !elements) {
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, stripe.confirmPayment({
                            elements: elements,
                            confirmParams: {
                                return_url: redirectUrl,
                            },
                        })];
                case 1:
                    error = (_a.sent()).error;
                    if (error.type === 'card_error' || error.type === 'validation_error') {
                        setMessage(error.message);
                    }
                    else {
                        setMessage('An unexpected error occurred.');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var paymentElementOptions = {
        layout: 'tabs',
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [paymentRequest && !useCard && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!walletError && ((0, jsx_runtime_1.jsx)(react_stripe_js_1.PaymentRequestButtonElement, { options: { paymentRequest: paymentRequest } })), walletError && (0, jsx_runtime_1.jsx)("div", __assign({ className: "stripe-message" }, { children: walletError })), (0, jsx_runtime_1.jsx)(CardButton, __assign({ onClick: function () { return setUseCard(true); } }, { children: "Tarjeta de d\u00E9bito o cr\u00E9dito." }))] })), (isWalletAvailable === false || useCard) && ((0, jsx_runtime_1.jsxs)("form", __assign({ className: "opo-checkout-buyform-stripe", onSubmit: handleSubmit }, { children: [message && (0, jsx_runtime_1.jsx)("div", __assign({ className: "stripe-message" }, { children: message })), (0, jsx_runtime_1.jsx)(react_stripe_js_1.PaymentElement, { id: "payment-element", options: paymentElementOptions }), (0, jsx_runtime_1.jsx)(ConfirmButton, __assign({ disabled: isLoading || !stripe || !elements, type: "submit", id: "submit" }, { children: isLoading ? 'Por favor, espere...' : 'Pagar ahora' }))] }))), isWalletAvailable === null && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "opo-checkout-buyform-loading" }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { color: "success", sx: { color: "#264653" } }) })))] }));
};
exports.default = Stripe;
//# sourceMappingURL=Stripe.js.map